import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_BY_CREATIVES = gql`
  query campaignOrderTransactionCreativeses($id: ID!) {
    campaignOrderTransactionCreativeses(
      where: { campaignOrderTransactionReport: { analytics: { campaignOrder: { id: $id } } } }
    ) {
      media
      name
      impressions
      transactions
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_BY_CREATIVES;
